import { useEffect } from 'react';
import { EventProperties } from '@segment/analytics-next';

import { Segment } from '../../clients';
import { types } from './definitions';
import { useUserDetails } from '../../hooks';

// wraps Segment client and UserContext in order to facilitate
// end-user identification as well as segmenting tracked events based on
// login state
const useSegment = (): types.UseSegmentHookValues => {
  const { isLoggedIn, account, user, isLoading } = useUserDetails();
  const accountSid = account?.sid;
  const userSid = user?.sid;

  useEffect(() => {
    if (!isLoading) {
      Segment.identifyUser({ accountSid, userSid });
      Segment.addGlobalEventAttribute({ isAuthenticated: isLoggedIn });
    }
  }, [isLoading, accountSid, userSid, isLoggedIn]);

  return {
    trackEvent: (eventName: string, additionalValues?: EventProperties): void =>
      Segment.trackEvent(eventName, additionalValues),
    trackPage: (): void => Segment.trackPage(),
  };
};

export default useSegment;
